import { memo } from 'react';

import { Separator } from '@/components/core';
import { findField, FormatterValidatorHeader, ValidationFormSettings } from '@/components/ui';
import { useModelConfigStore } from '@/store';

export type UrlValidatorProps = {
  fieldId: string;
  validatorId: string;
};

const IUrlValidator = ({ fieldId, validatorId }: UrlValidatorProps) => {
  const field = useModelConfigStore((state) => findField(state.fields, fieldId));
  const validator = field?.validators?.find((v) => v.id === validatorId);

  return (
    <div className="flex h-full flex-col gap-4 p-4">
      <FormatterValidatorHeader validator={validator} />

      <Separator orientation="horizontal" />

      <ValidationFormSettings fieldId={fieldId} validatorId={validatorId} />
    </div>
  );
};

export const UrlValidator = memo(IUrlValidator) as typeof IUrlValidator;
